/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import { data } from './SampleCSVData';

export const page: {
  form: Item<'Form'>;
  root: Item<'Page'>;
  flexItem: Item<'FlexItem'>;
  actionShowMessage: Item<'ActionShowMessage'>;
  rowPanel: Item<'RowPanel'>;
  flexPanel: Item<'FlexPanel'>;
  columnPanel: Item<'ColumnPanel'>;
  columnPanel1: Item<'ColumnPanel'>;
  columnPanel2: Item<'ColumnPanel'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  dataStoreReference: Item<'DataStoreReference'>;
  localDataStore: Item<'LocalDataStore'>;
  actionCreate: Item<'ActionCreate'>;
  actionClear: Item<'ActionClear'>;
  triggerOnPageActive: Item<'TriggerOnPageActive'>;
} = {
  actionClear: {
    children: [],
    itemId: 'actionClear',
    parent: 'triggerOnPageActive',
    props: {
      alias: 'alias',
    },
    type: 'ActionClear',
  },
  actionCreate: {
    children: [],
    itemId: 'actionCreate',
    parent: 'triggerOnPageActive',
    props: {
      alias: 'alias',
    },
    type: 'ActionCreate',
  },
  columnPanel: {
    children: [],
    itemId: 'columnPanel',
    parent: 'rowPanel',
    props: {},
    type: 'ColumnPanel',
  },
  columnPanel1: {
    children: ['form'],
    itemId: 'columnPanel1',
    parent: 'rowPanel',
    props: { colHeight: '100%' },
    type: 'ColumnPanel',
  },
  columnPanel2: {
    children: [],
    itemId: 'columnPanel2',
    parent: 'rowPanel',
    props: {},
    type: 'ColumnPanel',
  },
  dataStoreReference: {
    children: ['rowPanel'],
    itemId: 'dataStoreReference',
    parent: 'flexItem',
    props: {
      alias: 'alias',
    },
    type: 'DataStoreReference',
  },
  flexItem: {
    children: ['dataStoreReference'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  form: {
    children: [],
    itemId: 'form',
    parent: 'columnPanel1',
    props: {},
    type: 'Form',
  },
  root: {
    children: ['localDataStore', 'flexPanel', 'triggerOnPageActive'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  rowPanel: {
    children: ['columnPanel', 'columnPanel1', 'columnPanel2'],
    itemId: 'rowPanel',
    parent: 'dataStoreReference',
    props: {
      gridHeight: {
        type: '%',
        value: 100,
      },
    },
    type: 'RowPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'alias',
      data,
      dataSource: 'ds',
    },
    type: 'LocalDataStore',
  },
  triggerOnPageActive: {
    children: ['actionClear', 'actionCreate'],
    itemId: 'triggerOnPageActive',
    parent: 'root',
    props: {},
    type: 'TriggerOnPageActive',
  },
  triggerOnClick: {
    children: ['actionShowMessage'],
    itemId: 'triggerOnClick',
    parent: 'button',
    props: {},
    type: 'TriggerOnClick',
  },
  actionShowMessage: {
    children: [],
    itemId: 'actionShowMessage',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'expression',
        // eslint-disable-next-line no-template-curly-in-string
        value: '`Button with label ${$.$page.button.text.value} got clicked!`',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
};
